import { render, staticRenderFns } from "./blob_content_viewer.vue?vue&type=template&id=45a8d06d"
import script from "./blob_content_viewer.vue?vue&type=script&lang=js"
export * from "./blob_content_viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports